<template>
    <div class="card-section d-flex align-center justify-center">
        <v-card class="support-card" elevation="12">
            <div class="card-text-group">
                <span class="card-title">Contact Us</span>
                <div class="card-subtitle">
                    <p>
                        If you have a question that is not listed in our FAQs,
                        have general comments or suggestions, or you need
                        further assistance with an issue, click
                        <span class="attention">Contact Us</span> below to email
                        our support team.
                    </p>
                    <div class="card-important">
                        <h3 class="important-title">Important:</h3>
                        <div class="important-information">
                            <p>
                                For help with PIN assistance or redemption
                                issues, you must attach a photo or image of:
                            </p>
                            <ul class="required">
                                <li class="required-item">
                                    The back of your card
                                </li>
                                <li class="required-item">
                                    Your receipt or other proof of purchase
                                </li>
                            </ul>
                            <p>
                                For redemption issues, please include the Game
                                Title and Publisher Name in addition to your
                                photos/images.
                            </p>
                        </div>
                        <span class="error-text"
                            >*We cannot provide support without these
                            files/information.</span
                        >
                    </div>
                </div>
            </div>

            <div class="support-card-btn-wrapper">
                <v-btn
                    class="support-card-btn mt-12"
                    rounded
                    width="180"
                    height="54"
                    :ripple="false"
                    :href="
                        `mailto:support@nexongamecard.com?subject=${encodeURIComponent(
                            `[Nexon Game Card Support]`
                        )}&body=${encodeURIComponent(
                            `How can we help you?\nEnter your question or the details of your issue and attach supporting files, as needed.`
                        )}`
                    "
                    link
                >
                    <span id="support-btn-contact-form-submit">CONTACT US</span>
                </v-btn>
            </div>
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'contact-form',
};
</script>

<style lang="scss" scoped>
.input-heading {
    font-size: 16px;
}

.card-section {
    width: 100%;
    height: 100%;
    margin-top: 60px;
    padding: 0 30px;
    color: #333333;
    .support-card {
        width: 100%;
        padding: 60px;
        border-radius: 6px;
        .card-text-group {
            display: flex;
            flex-direction: column;
            .card-title {
                margin-left: auto;
                margin-right: auto;
                font-size: 24px;
                font-weight: bold;
                line-height: normal;
                letter-spacing: normal;
                margin-bottom: 35px;
            }
            .card-subtitle {
                font-size: 14px;
                margin-bottom: 10px;

                .attention {
                    font-weight: bold;
                }
            }
            .card-fields-required {
                font-size: 12px;
            }
        }
        .support-card-btn-wrapper {
            width: 100%;
            text-align: center;
        }
    }
    .card-important {
        margin-top: 40px;
        .important-title {
            text-transform: uppercase;
            font-family: 'ArialMT', 'Arial', sans-serif;
            font-style: italic;
            font-weight: 700;
            line-height: normal;
            margin-bottom: 15px;
        }
        .important-information {
            padding: 37px 51px;
            box-sizing: border-box;
            background-color: rgba(0, 156, 210, 0.07);
        }
        .required {
            padding: 18px 0 28px 30px;

            .required-item {
                padding: 0 0 10px 10px;
            }
        }

        .error-text {
            font-size: 11px;
            font-family: 'ArialMT', 'Arial', sans-serif;
            font-style: italic;
            color: #ff0000;
            line-height: normal;
        }
    }
}

.support-card-btn {
    position: static;
    background-color: #2960e8 !important;
    color: #ffffff;
    &:hover {
        box-shadow: 0 8px 15px 0 #5776cf !important;
    }
    &:focus {
        background-color: #2960e8 !important;
        box-shadow: none !important;
    }
}

@media (max-width: 470px) {
    .card-section {
        .support-card {
            padding: 10px;
        }
        .card-important {
            .important-information {
                padding: 10px;
            }
        }
    }
}

@include break('md') {
    .card-section {
        .support-card {
            padding: 60px;
        }
    }
}
@include break('xl') {
    .card-section {
        margin-top: 0;
        .support-card {
            margin-top: -150px;
            width: 584px;
        }
    }
}
</style>
